export default "__VITE_ASSET__BE3hAcEl__"